import styled from '@emotion/styled';
import {motion} from 'framer-motion';

const handleSize = 20;

export const Wrapper = styled(motion.div)`
  position: absolute;
  top: calc(50% - ${handleSize / 2}px);
  left: -${handleSize / 2}px;
  transform-origin: center;
  height: ${handleSize}px;
  width: ${handleSize}px;
  background-color: #ffffff;
  border-radius: 50%;
  pointer-events: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

interface ContainerProps {
  left: string;
}

export const Container = styled.div<ContainerProps>`
  transform: translate(${({left}) => left}, 0);
`;
